<template>
    <svg :height="totalHeight" width="100%">
        <line x1="0" y1="0" x2="100%" y2="0"
              v-bind:stroke="hexCode" v-bind:stroke-width="mainLineHeight"/>
        <line x1="0" :y1="mainLineHeight" :x2="accentWidth" :y2="mainLineHeight"
              v-bind:stroke="hexCode" v-bind:stroke-width="accentLineHeight"/>
    </svg>
</template>

<script>
    export default {
        name: 'seder-divider',
        props: ['hexCode'],
        data: function () {
            return {
                mainLineHeight: 1,
                accentLineHeight: 8,
                accentWidth: 120,
            }
        },
        computed: {
            totalHeight: function () {
                return this.mainLineHeight + this.accentLineHeight
            }
        }
    }
</script>
